module.exports = __webpack_public_path__ + "static/media/not-found.1d834da1.jpg";